import TagManager from 'react-gtm-module';
import { KeyTextField } from '@prismicio/client';

export enum PromoBarLevels {
  level_1 = 'level 1',
  level_2 = 'level 2',
}

export interface TrackPromoBarClickProps {
  data: {
    level: PromoBarLevels;
    linkUrl: string | null;
    linkText: KeyTextField;
    menuPath: KeyTextField;
  };
}

export const trackPromoBarClick = ({ data }: TrackPromoBarClickProps) => {
  const { level, linkUrl, linkText, menuPath } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_promobar',
      interaction: {
        interaction_location: level,
        ...(linkUrl !== undefined && { link_url: linkUrl }),
        ...(linkText && { link_text: linkText }),
        ...(menuPath && { menu_path: menuPath }),
      },
    },
  });
};
